<template>
  <ul v-if="props">
    <li
      v-if="props.field"
      :class="{ bold: props.field.showBubbles }"
    >
      {{ truncatedList }}
    </li>
    <HierarchyItemChildren
      v-if="props.child"
      :level1="level1"
      :props="props.child"
    />
  </ul>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'
import { FieldMapItem } from '@/types'

interface HierarchyItemProps {
  field: FieldMapItem,
  items: string[],
  child?: HierarchyItemProps
}

const props = {
  level1: String as PropType<string>,
  props: Object as PropType<HierarchyItemProps | undefined>,
}

@Component({ name: 'HierarchyItemChildren' })
export default class HierarchyItemChildren extends Vue.extend({ props }) {
  get truncatedList (): string {
    const { items } = this.props as HierarchyItemProps
    return items.slice(0, 10).join(', ') + (items.length > 10 ? ', ...' : '')
  }
}
</script>

<style scoped>
.bold {
  font-weight: bold;
}
li {
  font-weight: normal;
}
</style>
